import client from './client';

export interface CreateLinkRequest {
    order_number: string;
    link_type?: 'all' | 'upi';
}

export interface PaymentLinkResponse {
    payment_link: string;
    payment_link_id: string;
    order_id: string;
    amount: number;
    status: string;
    items_count: number;
    delivery_date?: string;
    delivery_slot?: string;
}

export interface PaymentLinkHistoryItem {
    id: number;
    order_id: number;
    order_number: string;
    customer_name: string;
    amount: number;
    payment_link_id: string;
    short_url: string;
    status: string;
    razorpay_payment_id?: string;
    created_at: string;
    updated_at: string;
}

export interface HistoryResponse {
    items: PaymentLinkHistoryItem[];
    total: number;
    limit: number;
    offset: number;
}

export const razorpayAPI = {
    createPaymentLink: async (data: CreateLinkRequest): Promise<PaymentLinkResponse> => {
        const response = await client.post('/razorpay/create-link', data);
        return response.data;
    },

    getHistory: async (limit: number = 20, offset: number = 0): Promise<HistoryResponse> => {
        const response = await client.get('/razorpay/history', { params: { limit, offset } });
        return response.data;
    },

    deleteHistoryItem: async (id: number): Promise<{ status: string; message: string }> => {
        const response = await client.delete(`/razorpay/history/${id}`);
        return response.data;
    }
};
